import React from "react";
import { FromComponent } from "../../theme/theme"
import { language } from "../../utils/language";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";

const AddFrom = (props: any) => {
  const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);

  if (!(props.product.references && props.product.references.length > 0)) {
    return <FromComponent></FromComponent>
  }
  const itemRef = props.product.references[0]
  const itemRef2 = props.product.references.find((field: any) => (!props.field && field.amount !== itemRef.amount) || (props.field && field[props.field] !== itemRef[props.field]))
  return itemRef2 ? <>
    <FromComponent fontSize={props.fontSize} fontWeight={props.fontWeight}>{language[homeState.default_language]["from"]} </FromComponent>
    {props.br && <br></br>}
  </>  : <FromComponent></FromComponent>
}

export default AddFrom;
